import React from 'react';
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

import useHook from './hook';
import colors from '../../../../assets/colors';

type IndicatorProps = {
	percentVisible?: boolean;
	callback(): void;
};

export const Indicator: React.FC<IndicatorProps> = ({
	percentVisible,
	callback = () => null,
}) => {
	const { loader } = useHook({ callback });

	return (
		<div>
			<CircularProgressbar
				value={loader}
				text={`${loader}%`}
				strokeWidth={5}
				styles={{
					root: {
						width: 200,
						height: 200,
					},
					text: {
						fill: colors.black,
						fontSize: 18,
					},
					path: {
						stroke: colors.green,
						transition: 'stroke-dashoffset 0.5s ease 0s',
					},
					trail: {
						stroke: colors.border,
					},
				}}
			/>
		</div>
	);
};
